/** ShopRegister 画面の文言取得用スクリーン名。 */
export const SHOP_REGISTER_FILE_NAME = "ShopRegister";
export const SHOP_REGISTER_SCREEN_NAME = SHOP_REGISTER_FILE_NAME;

/** 配送依頼登録画面の文言取得用スクリーン名。 */
export const REGISTRATION_DELIVERY_REQUEST_FILE_NAME =
  "RegistrationDeliveryRequest";
export const REGISTRATION_DELIVERY_REQUEST_SCREEN_NAME =
  REGISTRATION_DELIVERY_REQUEST_FILE_NAME;

// Fieldのname属性で使用される必要なラベルキー（OperatorRegister.vueと同様のパターン）
export const REQUIRED_FIELD_LABEL_KEYS = [
  "lbl_shop_regist",
  "lbl_chain_name",
  "lbl_shop_code",
  "lbl_shop_name",
  "plc_selectbox",
  "lbl_no_data_text",
  "lbl_shop_name_kana",
  "lbl_dss_connection_id",
  "lbl_dss_shop_code",
  "lbl_dss_shop_name",
  "lbl_address",
  "lbl_address_detail",
  "lbl_room_num",
  "lbl_tel",
  "lbl_fax",
  "lbl_cur_deliverable_display_method",
  "lbl_alert_upper_threshold",
  "lbl_shipping_label_print_flg",
  "lbl_delivery_order_print_flg",
  "lbl_delivery_request_notification_emails",
  "lbl_double_deli_oricon_count",
  "lbl_charter_deli_oricon_count",
  "lbl_temp_member_registration_flg",
] as const;
